module.exports = __webpack_public_path__ + "img/sortImg1-1-1.0a5fa723.png";